import { isFogo } from './appEnvironment';
import type { ISettings } from './interfaces';

export const SETTINGS_DEFAULT: ISettings = {
	explorerOpens: 'sidebar',
	explorer: isFogo() ? 'https://explorer.fogo.io' : 'https://solscan.io',
	customRpcUrl: '',
	slippage: 5,
	validatorTip: null,
	priorityFeeMax: 0.0,
	priorityLevel: 'market',
	validatorLevel: 'market',
	swapValues: {
		sell: [10, 15, 25, 50, 75, 100],
		buy: [0.1, 0.25, 0.5, 1],
	},
	instantBuy: false,
	keyboardShortcuts: {
		enabled: false,
		shortcuts: {
			search: {
				key: '=',
				description: 'Open token search',
				enabled: false,
				action: 'search',
			},
			sell: {
				key: '[',
				description: 'Sell token',
				enabled: false,
				action: 'sell',
				amount: { type: 'percentage', value: 25, action: 'sell' },
			},
			buy: {
				key: ']',
				description: 'Buy token',
				enabled: false,
				action: 'buy',
				amount: { type: 'percentage', value: 25, action: 'buy' },
			},
			cycleIntervalLeft: {
				key: ',',
				description: 'Cycle trending token time interval left',
				enabled: false,
				action: 'cycleIntervalLeft',
			},
			cycleIntervalRight: {
				key: '.',
				description: 'Cycle trending token time interval right',
				enabled: false,
				action: 'cycleIntervalRight',
			},
			help: {
				key: '/',
				description: 'Open keyboard shortcut help',
				enabled: false,
				action: 'help',
			},
		},
		customAmountShortcuts: [],
	},
};
